var render = function render(_c,_vm){return _c('div',{staticClass:"foo"},[(!_vm.props.row.Employee.imageUrl)?_c('el-avatar',{attrs:{"size":"small","src":"/static/images/avatar-2.jpg"}}):_c('el-avatar',{attrs:{"size":"small","src":_vm.props.row.Employee.imageUrl}}),_c('span',[_vm._v(_vm._s(_vm.props.row.Employee.FullName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }